document.addEventListener('DOMContentLoaded', function() {

  // ─── FORM CORPORATE (#form-corporate-preventivo) ─────────────────────────

  // Mappa prodotto → MOQ costruita dai data attribute delle schede
  var moqMap = {};
  document.querySelectorAll('a[data-prodotto]').forEach(function(link) {
    var prodotto = link.getAttribute('data-prodotto');
    var moq = link.getAttribute('data-moq');
    if (prodotto && moq) moqMap[prodotto.toLowerCase()] = moq;
  });

  // Funzione per aggiornare il placeholder quantità
  function aggiornaMoq(nomeProdotto) {
    var quantita = document.getElementById('quantita')
      || document.querySelector('#form-corporate-preventivo input[name="quantita"]')
      || document.querySelector('#form-corporate-preventivo input[type="number"]');
    if (!quantita) return;
    var moq = moqMap[nomeProdotto.toLowerCase()];
    if (moq) {
      quantita.placeholder = 'es. ' + moq + ' pz (minimo per questo prodotto)';
    } else {
      quantita.placeholder = 'scrivi un numero';
    }
  }

  // Click sui bottoni "Richiedi offerta" nelle schede
  document.querySelectorAll('a[data-prodotto]').forEach(function(link) {
    link.addEventListener('click', function() {
      var prodotto = this.getAttribute('data-prodotto');
      setTimeout(function() {
        var select = document.getElementById('prodotto');
        if (select && prodotto) {
          var options = select.options;
          for (var i = 0; i < options.length; i++) {
            if (options[i].value.toLowerCase() === prodotto.toLowerCase()) {
              select.value = options[i].value;
              break;
            }
          }
        }
        aggiornaMoq(prodotto);
      }, 150);
    });
  });

  // Cambio manuale del select prodotto nel form corporate
  var selectCorporate = document.getElementById('prodotto');
  if (selectCorporate) {
    selectCorporate.addEventListener('change', function() {
      if (this.value) {
        aggiornaMoq(this.value);
        var quantita = document.getElementById('quantita')
          || document.querySelector('#form-corporate-preventivo input[name="quantita"]')
          || document.querySelector('#form-corporate-preventivo input[type="number"]');
        if (quantita) quantita.value = '';
        var errore = document.getElementById('moq-errore');
        if (errore) errore.remove();
      }
    });
  }

  // Invio AJAX form corporate
var formCorporate = document.getElementById('form-corporate-preventivo');

if (formCorporate) {

  // Tracciamento prima interazione reale con il form
  var corporateFormStarted = false;

  function trackCorporateFormStart(e) {
    if (corporateFormStarted) return;

    var target = e.target;

    // Esclude campi hidden e checkbox Privacy
    if (target.type === 'hidden' || target.type === 'checkbox') return;

    corporateFormStarted = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ubp_corporate_form_start'
    });
  }

  formCorporate.addEventListener('input', trackCorporateFormStart);
  formCorporate.addEventListener('change', trackCorporateFormStart);

  formCorporate.addEventListener('submit', function(e) {
      e.preventDefault();

      // Validazione MOQ
      var selectEl = document.getElementById('prodotto');
      var quantita = document.getElementById('quantita')
        || document.querySelector('#form-corporate-preventivo input[name="quantita"]')
        || document.querySelector('#form-corporate-preventivo input[type="number"]');
      if (selectEl && quantita) {
        var prodotto = selectEl.value;
        var moq = prodotto ? moqMap[prodotto.toLowerCase()] : null;
        if (moq && parseInt(quantita.value) < parseInt(moq)) {
          var errore = document.getElementById('moq-errore');
          if (!errore) {
            errore = document.createElement('small');
            errore.id = 'moq-errore';
            errore.style.cssText = 'display:block;margin-top:6px;color:#c0392b;font-size:0.85em;font-weight:600;';
            quantita.parentNode.insertBefore(errore, quantita.nextSibling);
          }
          errore.textContent = 'La quantità minima per questo prodotto è ' + moq + ' pz.';
          quantita.value = '';
          quantita.focus();
          return;
        } else {
          var errore = document.getElementById('moq-errore');
          if (errore) errore.remove();
        }
      }

      var data = new FormData(formCorporate);
      var submitBtn = formCorporate.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Invio in corso...';
      }

      fetch(formCorporate.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(response) {
  if (response.ok) {

    var redirected = false;

    function goToThankYouCorporate() {
      if (redirected) return;
      redirected = true;
      window.location.href = 'https://ubuntupack.com/pages/grazie-corporate-gifting-ubuntu-green-gifts';
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'ubp_corporate_success',
      eventCallback: goToThankYouCorporate,
      eventTimeout: 2000
    });

    setTimeout(goToThankYouCorporate, 2500);

  } else {
    return response.json().then(function(data) {
      throw new Error(data.error || 'Errore durante l\'invio');
    });
  }
})
      .catch(function(error) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'INVIA RICHIESTA';
        }
        alert('Si è verificato un errore durante l\'invio. Riprova o contattaci via email.');
        console.error('Formspree error:', error);
      });
    });
  }

  // ─── FORM ACQUA (#form-acqua-preventivo) ─────────────────────────────────

  var formAcqua = document.getElementById('form-acqua-preventivo');

if (formAcqua) {

  // Tracciamento prima interazione reale con il form
  var acquaFormStarted = false;

  function trackAcquaFormStart(e) {
    if (acquaFormStarted) return;

    var target = e.target;

    // Esclude campi hidden e checkbox Privacy
    if (target.type === 'hidden' || target.type === 'checkbox') return;

    acquaFormStarted = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ubp_acqua_form_start'
    });
  }

  formAcqua.addEventListener('input', trackAcquaFormStart);
  formAcqua.addEventListener('change', trackAcquaFormStart);

  formAcqua.addEventListener('submit', function(e) {
      e.preventDefault();
      var data = new FormData(formAcqua);
      var submitBtn = formAcqua.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Invio in corso...';
      }
      fetch(formAcqua.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(res) {
  if (res.ok) {

    var redirected = false;

    function goToThankYouAcqua() {
      if (redirected) return;
      redirected = true;
      window.location.href = 'https://ubuntupack.com/pages/grazie-acqua-brick-ubuntu-green-gifts';
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'ubp_acqua_success',
      eventCallback: goToThankYouAcqua,
      eventTimeout: 2000
    });

    setTimeout(goToThankYouAcqua, 2500);

  } else {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'INVIA RICHIESTA';
    }
    alert('Errore nell\'invio. Riprova o scrivici a hello@ubuntugreengifts.com');
  }
})
      .catch(function() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'INVIA RICHIESTA';
        }
        alert('Errore di rete. Riprova o scrivici a hello@ubuntugreengifts.com');
        });
    });
  }

});